import { render, staticRenderFns } from "./LesVoltesOct2020Page.vue?vue&type=template&id=4cba4561"
import script from "./LesVoltesOct2020Page.vue?vue&type=script&lang=js"
export * from "./LesVoltesOct2020Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports